import { useEffect, useRef } from 'react';
import { useUnmount } from '../useUnmount/index';
var DEFAULT_OPTION = {
  preservePreTitle: true
};

function usePageTitle(title, options) {
  if (options === void 0) {
    options = DEFAULT_OPTION;
  }

  var preTitleRef = useRef(document.title);
  useEffect(function () {
    document.title = title;
  }, [title, options]);
  useUnmount(function () {
    if (options.preservePreTitle) {
      document.title = preTitleRef.current;
    }
  });
}

export { usePageTitle };